import { ADV } from "../../interfaces"
import { AutocompleteElement } from "react-hook-form-mui"
import { useCategoriesListQuery } from "../../store"
import { useEffect, useState } from "react"
import { Box, Typography } from "@mui/material"

interface IProps {
  required?: boolean
}
interface IField {
  // category_id: ADV.Category["id"]
}
interface FlatCategory extends ADV.Category {
  level: number
  topLevelName: string
}

const flattenCategories = (
  categories: ADV.Category[],
  level: number = 0,
  topLevelName: string = "",
) => {
  return categories.reduce<FlatCategory[]>((acc, category) => {
    // Определяем верхний уровень
    const currentTopLevelName = topLevelName || category.name

    if (category.category_child && category.category_child.length > 0) {
      acc.push(
        ...flattenCategories(
          category.category_child,
          level + 1,
          currentTopLevelName,
        ),
      )
    } else {
      acc.push({ ...category, level, topLevelName: currentTopLevelName })
    }

    return acc
  }, [])
}

export const Category = <T extends IField>({ required }: IProps) => {
  const { data, isFetching: isLoading } = useCategoriesListQuery({})
  const [categories, setCategories] = useState<null | ADV.Category[]>(null)

  useEffect(() => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      setCategories(null)
      return
    }

    setCategories(flattenCategories(data))
  }, [data])

  return (
    <AutocompleteElement
      name="payment.category_id"
      label="Категория"
      required={required}
      matchId
      loading={isLoading}
      autocompleteProps={{
        fullWidth: true,
        getOptionLabel: (option: FlatCategory) => option?.name,
        groupBy: (option) => option.topLevelName,
      }}
      options={categories ?? []}
    />
  )
}
